window.Products.DeviceCase.GalaxyS5 = function() {
};
window.Products.DeviceCase.GalaxyS5.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS5.id = 19;
window.Products.DeviceCase.GalaxyS5.slug = 'galaxy-s5';